import { render, staticRenderFns } from "./psychologyScheduleDialog.vue?vue&type=template&id=6626a9b1&"
import script from "./psychologyScheduleDialog.vue?vue&type=script&lang=js&"
export * from "./psychologyScheduleDialog.vue?vue&type=script&lang=js&"
import style0 from "./psychologyScheduleDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports